exports = module.exports = require("../../../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/* https://github.com/servicetitan/anvil/issues/462 */\n.yes-no-confirmation.without-message .Modal__header {\n    border-bottom: none;\n}\n\n.yes-no-confirmation.without-message .Modal__content {\n    display: none;\n}\n\n.yes-no-confirmation.without-message .Modal__footer {\n    border-top: none;\n}\n", ""]);

// exports
